import React, { useEffect } from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
import { AiFillCheckSquare } from "react-icons/ai";
const Option = Select.Option

@Form.create()
class ViewEmployeeDetails extends React.Component {
    state = {
        visible: true,
        loading: false,
        leaveApproved: false,
        leaveTypes: ['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)'],
        allUsers: [],
        record: {}

    }



    componentDidMount() {

    }


    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }
    render() {
        const { record } = this.props

        const {
            form: { getFieldDecorator, }
        } = this.props

        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Detail:- {record.name}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={500}
                visible={this.state.visible}>
                <Card>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ marginTop: '10px' }}>
                            <h2>General Information</h2>
                            <table style={{ width: '80%', textAlign: 'center' }}>
                                <tbody>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Name</th>
                                        <td>{record.name}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Permanent Address with Pincode</th>
                                        <td>{record.permanentAddress}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Current Address with Pincode</th>
                                        <td>{record.temporaryAddress}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Personal Contact Number</th>
                                        <td>{record.contactNo}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Personal Email Id</th>
                                        <td>{record.personalEmail}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Emergency Number</th>
                                        <td>{record.emergencyPhone}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Emergency Contact Person</th>
                                        <td>{record.emergencyPerson}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Date of Birth</th>
                                        <td>{moment(record.dob).format('DD-MMMM-YYYY')}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Father Name</th>
                                        <td>{record.fatherName}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Marital Status</th>
                                        <td>{record.maritalStatus}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Aadhar Number</th>
                                        <td>{record.aadharNumber}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Pan Number</th>
                                        <td>{record.panNumber}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Any Sibling</th>
                                        <td>{record.sibling}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Any Medical Illness</th>
                                        <td>{record.medicalIllness}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Current Salary</th>
                                        <td>{record.salary}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Husband/Wife Name</th>
                                        <td>{record.husbandWifeName}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Husband/Wife DOB</th>
                                        <td>{moment(record.husbandWifeDob).format('DD-MMMM-YYYY')}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Children Name (If Any)</th>
                                        <td>{record.childrenName}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Children dob</th>
                                        <td>{moment(record.childrenDob).format('DD-MMMM-YYYY')}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Mother's Name</th>
                                        <td>{record.motherName}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Mother's DOB</th>
                                        <td>{moment(record.motherDob).format('DD-MM-YYYY')}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Father's DOB</th>
                                        <td>{moment(record.fatherDob).format('DD-MMMM-YYYY')}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Sibling Name (If Any)</th>
                                        <td>{record.siblingName}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Sibling DOB</th>
                                        <td>{moment(record.siblingDob).format('DD-MMMM-YYYY')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <h2>Bank Details</h2>
                            <table style={{ width: '80%', textAlign: 'center' }}>
                                <tbody>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Bank Name</th>
                                        <td>{record.bankDetails.bankName}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Bank Account Number</th>
                                        <td>{record.bankDetails.accountNumber}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Name in Bank Account</th>
                                        <td>{record.bankDetails.accountName}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>IFSC Code</th>
                                        <td>{record.bankDetails.ifsc}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <h2>Previous Experience</h2>
                            <table style={{ width: '80%', textAlign: 'center' }}>
                                <tbody>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Last Employer Name</th>
                                        <td>{record.previousEmployerName}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Last Company Name</th>
                                        <td>{record.previousCompanyName}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Total Experience</th>
                                        <td>{record.previousExperience}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Last Salary</th>
                                        <td>{record.previousSalary}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <h2>Academic Details</h2>
                            <table style={{ width: '80%', textAlign: 'center' }}>
                                <tbody>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Highest Qualification</th>
                                        <td>{record.highestQualification}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>University/College</th>
                                        <td>{record.universityorCollege}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <h2>Documents</h2>
                            <table style={{ width: '80%', textAlign: 'center' }}>
                                <tbody>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Pan Card</th>
                                        <td>{record.panCard && record.panCard.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Aadhar Card</th>
                                        <td>{record.aadharCard && record.aadharCard.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Academic Certificates</th>
                                        <td>{record.academicCertificates && record.academicCertificates.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Previous Experience Letter</th>
                                        <td>{record.previousExperienceCert && record.previousExperienceCert.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>3 Months Salary Slip</th>
                                        <td>{record.salarySlip && record.salarySlip.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Medical Illness Certificate</th>
                                        <td>{record.medicalIllnessCert && record.medicalIllnessCert.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Bank Passbook</th>
                                        <td>{record.bankPassbook && record.bankPassbook.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Passport Size Photo</th>
                                        <td>{record.photo && record.photo.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <h2>OnBoarding Details</h2>
                            <table style={{ width: '80%', textAlign: 'center' }}>
                                <tbody>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Employee Id</th>
                                        <td>{record.empId}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Designation</th>
                                        <td>{record.hireAs}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Date of Joining</th>
                                        <td>{moment(record.dateOfJoining).format('DD-MMMM-YYYY')}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Appointment Letter</th>
                                        <td>{record.appointmentCert && record.appointmentCert.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Employee Agreement</th>
                                        <td>{record.employeeAgreementCert && record.employeeAgreementCert.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Appraisal Letter</th>
                                        <td>{record.appraisalCert && record.appraisalCert.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Shift Timing</th>
                                        <td>{record.shiftTiming}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Joining Salary</th>
                                        <td>{record.joiningSalary}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Active Status</th>
                                        <td>{record.activeStatus}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <h2>Exit Details</h2>
                            <table style={{ width: '80%', textAlign: 'center' }}>
                                <tbody>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Relieving Date</th>
                                        <td>{moment(record.dateOfRelieving).format('DD-MMMM-YYYY')}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Relieving Letter</th>
                                        <td>{record.relievingCert && record.relievingCert.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Full & Final Statement Due</th>
                                        <td>{record.fullFinalSettlementDue}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Experience Letter </th>
                                        <td>{record.experienceLetter}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Experience Certificate </th>
                                        <td>{record.experienceCert && record.experienceCert.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>Letter of Intent</th>
                                        <td>{record.letterOfIntent && record.letterOfIntent.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>No Due Certificate</th>
                                        <td>{record.noDueCert && record.noDueCert.length > 0 ? <AiFillCheckSquare /> : null}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Card>
                {/* <Card>
                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                        <div>
                            
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    <Row>
                    <Col style={{textAlign:'center', marginTop:'10px'}}>
                            <h3>Previous Appraisals:- {record.lastAppraisals.length}</h3>
                                <table>
                                    <tbody bordered>
                                            <tr>
                                                <th>Appraisal Type</th>
                                                <th>Appraisal Date</th>
                                                <th>Salary After Appraisal</th>
                                            </tr>
                                        {record.lastAppraisals && record.lastAppraisals.map((item)=>(
                                            <tr>
                                                <td>{item.lastappraisalType}</td>
                                                <td>{moment(item.lastAppraisalDate).format('DD-MMMM-YYYY')}</td>
                                                <td>{item.salartAfterAppraisal * 8 * 30}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Col>
                    </Row>
                </Card> */}
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewEmployeeDetails)
